export function initializeModal() {
    $('[data-html-resource]').on('click', event => {
        event.preventDefault();
        const $id = $(event.target).attr('id');

        $.magnificPopup.open({
            fixedContentPos: 'fixed',
            closeBtnInside: false,
            items: {
                type: 'inline',
                src: `[data-ressource-html-popin-${$id}]`,
            },
        });
    });

    $('[data-html-quote-resource]').on('click', event => {
        event.preventDefault();
        const $id = $(event.target).attr('id');

        $.magnificPopup.open({
            fixedContentPos: 'fixed',
            closeBtnInside: false,
            items: {
                type: 'inline',
                src: `[data-ressource-html-popin-quote-${$id}]`,
            },
        });
    });
}
